import { Col, Layout, Modal, Row, theme } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { AuthContext } from "../../providers/AuthProvider";
import { useSelector, useDispatch } from "react-redux";
import {
  hideSessionExpiredModal,
  hideAccessDeniedModal,
} from "../../redux/slices/authSlice";

import SideBar from "../Sidebar";
import TopBar from "../TopBar";
import { assets } from "../../assets";
import { useGetMeQuery } from "../../redux/services/users";

const { Header, Content, Sider } = Layout;

const ProtectedLayout = () => {
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  const [collapsed, setCollapsed] = useState(true);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { authState, isAuthenticated } = useContext(AuthContext);

  const showSessionModal = useSelector((store) => store.auth.sessionExpired);
  const showAccessDenied = useSelector((store) => store.auth.accessDenied);

  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/login", { replace: true });
    }
  }, [isAuthenticated, navigate]);

  const handleOk = () => {
    dispatch(hideSessionExpiredModal());
    navigate("/login", { replace: true });
  };
  return (
    <Layout>
      <Header
        style={{
          padding: 0,
          background: colorBgContainer,
          position: "fixed",
          top: 0,
          left: 0,
          zIndex: 100,
          width: "100%",
          borderBottom: "1px solid rgba(0, 0, 0, 0.10)",
          height: "72px",
        }}
      >
        <TopBar />
      </Header>
      <Layout
        style={{
          paddingTop: "72px",
          zIndex: 0,
          background: "#F8F8F8",
          // backgroundImage: `url(${assets.backgroundImage})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          minHeight: "100vh",
        }}
      >
        <Sider
          width={230}
          collapsedWidth={68}
          // collapsible
          // onCollapse={(value) => setCollapsed(value)}
          onMouseEnter={() => setCollapsed(false)}
          onMouseLeave={() => setCollapsed(true)}
          collapsed={collapsed}
          theme="light"
          style={{
            position: "fixed",
            top: 72,
            left: 0,
            bottom: 0,
            zIndex: 2,
            height: `calc(100vh - 72px)`,
            boxShadow:
              "0px 12px 24px 0px rgba(0, 0, 0, 0.16), 0px 1px 2px 0px rgba(0, 0, 0, 0.08)",
            boxSizing: "border-box",
            overflowY: "auto",
          }}
        >
          <SideBar />
        </Sider>

        <Content
          style={{
            // paddingTop: "10px",
            zIndex: 0,
          }}
        >
          <Outlet />
          {authState.authenticated && <Outlet />}
        </Content>
      </Layout>
      <Modal
        title="Session Expired"
        open={showSessionModal}
        onOk={handleOk}
        cancelButtonProps={{ style: { display: "none" } }}
      >
        <p>Your account is logged in elsewhere. Please log in again.</p>
      </Modal>
      <Modal
        title="Access Denied"
        open={showAccessDenied}
        onOk={() => dispatch(hideAccessDeniedModal())}
        onCancel={() => dispatch(hideAccessDeniedModal())}
        okText="Got it"
        cancelButtonProps={{ style: { display: "none" } }}
        centered
        type="warning"
        style={{zIndex:1000}}
      >
        <p>You do not have permission to perform this action. Contact Admin.</p>
      </Modal>
    </Layout>
  );
};
export default ProtectedLayout;
